import React from "react";
import { useState, useEffect } from "react";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/Province.css";

const Province = ({
  provinceList,
  setProvinceList,
  selectedProvinceOption,
  setProvinceValue,
  close,
}) => {
  const [searchProvince, setSearchProvince] = useState("");

  // =====================================================

  let SearchPro = { options: [] };
  if (searchProvince) {
    SearchPro = {
      options: provinceList.options.filter((item) =>
        item.title.includes(searchProvince)
      ),
    };
  } else {
    SearchPro = provinceList;
  }

  const searchHandler = (e) => {
    const changeLetters = e.replace("ی", "ي");
    const deleteK = changeLetters.replace("ک", "ك");
    const deleteSecoundK = deleteK.replace("ک", "ك");
    const deleteSecoundY = deleteSecoundK.replace("ی", "ي");
    setSearchProvince(deleteSecoundY);
  };

  return (
    <div className="modal-wrapper mobile-bottom">
      <div className="Province">
        <div className="Province-inside">
          <div className="Province-inside-top">
            <div className="Province-inside-top-text">
              <p className="Province-inside-top-text-p">استان</p>
            </div>

            <div className="Province-inside-top-image" onClick={close}>
              <img
                className="Province-inside-top-image-img"
                src="imgs/Profile/editProfile.svg"
              />
            </div>
          </div>
          <div className="Province-inside-search">
            <input
              type="text"
              className="Province-inside-search-input"
              placeholder="جستجوی استان"
              onChange={(e) => searchHandler(e.target.value)}
            />
          </div>
          <div className="Province-inside-center">
            <ul className="Province-inside-center-ul">
              {SearchPro?.options?.map((item, i) => {
                const changeLetters = item.title.replace("ي", "ی");
                const deleteK = changeLetters.replace("ك", "ک");
                const deleteSecoundK = deleteK.replace("ك", "ک");

                return (
                  <li key={item.id}>
                    <input
                      type="radio"
                      hidden
                      id={item.id}
                      onClick={() => {
                        setProvinceValue(item);
                      }}
                      onChange={() => {
                        setProvinceValue(item);
                      }}
                      checked={selectedProvinceOption?.id == item.id}
                      name="answer"
                      className="Province-inside-center-ul-Option-input"
                      value={item.id}
                    />
                    <label
                      htmlFor={item.id}
                      className="Province-inside-center-ul-Option-label"
                    >
                      <div className="Province-inside-center-ul-Option-label-inside">
                        <div className="Province-inside-center-ul-Option-label-inside-inside-circle">
                          <svg height="40" width="40">
                            <circle cx="20" cy="20" r="10" className="circle" />
                          </svg>
                        </div>
                        <p className="Province-inside-center-ul-Option-label-inside-insid-text">
                          {deleteSecoundK.replace("ي", "ی")}
                        </p>
                      </div>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="Province-inside-bottom">
            <input
              onClick={() => {
                close();
              }}
              className="Province-inside-bottom-submit"
              type="submit"
              value="ثبت"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Province;
